import { render, staticRenderFns } from "./Mdistributed.vue?vue&type=template&id=58e9f84c&scoped=true&"
import script from "./Mdistributed.vue?vue&type=script&lang=js&"
export * from "./Mdistributed.vue?vue&type=script&lang=js&"
import style0 from "./Mdistributed.vue?vue&type=style&index=0&id=58e9f84c&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "58e9f84c",
  null
  
)

export default component.exports